import  DatadogService  from 'src/app/shared/datadog/datadog.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import AzureService from 'src/app/shared/services/azure.service';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import DataStatus from 'src/app/shared/models/datastatus.class';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ManageDependenciesModalComponent } from 'src/app/pulumi/components/manage-dependencies-modal/manage-dependencies-modal.component';


@Component({
  standalone: false,
  selector: 'app-app-settings-form',
  templateUrl: './app-settings-form.component.html',
  styleUrls: ['./app-settings-form.component.css']
})
export class AppSettingsFormComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public modalData: { webAppName: string },
    private _fb: FormBuilder,
    private _azureService: AzureService,
    private _manageDependenciesDialog: MatDialog,
    private _toastr: ToastrService,
    private _datadogService: DatadogService   
  ) {}
    
  
  public initialValues!: {[key: string]: string}  
  public webappSettingsDataStatus = new DataStatus()
  public submitFormStatus = new DataStatus()
  public webAppsFormGroup: FormGroup = new FormGroup({
    appSettings: new FormArray([])
  })  

  public webAppName!: string; 

  ngOnInit(): void {    
    this.webAppName = this.modalData.webAppName;
    this.getWebAppSettingsAndFillForm();
  }

  public getWebAppSettingsAndFillForm(): void {
    this._azureService.getWebAppSettings(this.webAppName)
      .subscribe({
        next: (res: any) => {
          this.initialValues = res         
          this.webappSettingsDataStatus.loading.set(false)
          this.webappSettingsDataStatus.completed.set(true)
          this.webappSettingsDataStatus.error.set(false)             
          this.addFormKeys(res)        
        },
        error: (err: HttpErrorResponse) => {
          this.webappSettingsDataStatus.loading.set(false)
          this.webappSettingsDataStatus.completed.set(true)
          this.webappSettingsDataStatus.error.set(true)         
          this._toastr.error("Ocorreu um erro")
        }
    })   
  }

  public addFormKeys(res: Object): void {       
    Object.entries(res)
      .forEach(([key, value]) => {      
        this.getAppSettingsPair.push(new FormGroup({
            key: new FormControl(key, [Validators.required]),
            value: new FormControl(value, [Validators.required]),
            keyFromDependency: new FormControl(false)
          }))
      })
  }

  get getAppSettingsPair(): FormArray {
    return this.webAppsFormGroup.get('appSettings') as FormArray
  }

  public addNewField(key?: string, value?: string, keyFromDependency?: boolean): void { 
    const newField = this._fb.group({
      key: [key ? key : 'NewField', [Validators.required]],
      value: [value ? value : '', [Validators.required]],
      keyFromDependency: [keyFromDependency ? true : false]    
    })      
    this.getAppSettingsPair.push(newField)
    this.webAppsFormGroup.markAsDirty()
  }  

  public overrideFormControl(index: number, value: any): void {
    this.getAppSettingsPair.at(index).patchValue(value)
    this.webAppsFormGroup.markAsDirty()
  }
  
  public onSubmit(webAppName: string): void {     
    this.submitFormStatus.loading.set(true)    
    this._azureService.updateWebAppSettings(webAppName, this.webAppsFormGroup.get('appSettings')?.value)
      .subscribe({
        next: () => { 
          this._datadogService.logInfo(`O Webapp ${webAppName} teve suas chaves atualizadas`, {
            oldValues: this.initialValues,
            newValues: this.transformArrayToKeyValue(this.webAppsFormGroup.get('appSettings')?.value) 
          })          
          this.initialValues = {}
          this.initialValues = this.transformArrayToKeyValue(this.webAppsFormGroup.get('appSettings')?.value)                 
          this.resetFields()           
          this.webAppsFormGroup.markAsPristine()              
          this.submitFormStatus.loading.set(false)
          this.submitFormStatus.completed.set(true)
          this.submitFormStatus.error.set(false)   
        },
        error: (e: any) => {
          this.submitFormStatus.loading.set(false)
          this.submitFormStatus.completed.set(true)
          this.submitFormStatus.error.set(true)
          this._datadogService.logError(`Ocorreu um erro ao atualizar as chaves do Webapp ${webAppName}`, e) 
        },
        complete: () => {       
          setTimeout(() => {
            this.submitFormStatus.completed.set(false)
          }, 2000)
        }
      })           
  }

  public resetFields() {     
    this.webAppsFormGroup = new FormGroup({
      appSettings: new FormArray([])
    })     
    this.addFormKeys(this.initialValues)
  }

  public transformArrayToKeyValue(array: []) {
    const newObject: {[key: string]: string} = {}
    array.forEach((key: any) => {             
      newObject[key.key] = key.value  
    })    
    return newObject      
  }

  public openManageDependenciesModal(): void {
    this._manageDependenciesDialog.open(ManageDependenciesModalComponent, {
      width: "45%",
      height: "100vh",
      position: {
        right: '0px'
      }  
    }).afterClosed()
        .subscribe((data) => {            
          if(data && this.getAppSettingsPair.value.map((value: any) => { return value.key}).indexOf(environment.organizationWebVersionReferenceKey) === -1)  
            this.addNewField( environment.organizationWebVersionReferenceKey,data?.organizationWebVersion,data?.keyFromDependency)
          else if(data && this.getAppSettingsPair.value.map((value: any) => { return value.key}).indexOf(environment.organizationWebVersionReferenceKey) != -1) {
            var index = this.getAppSettingsPair.value.map((value: any) => { return value.key}).indexOf(environment.organizationWebVersionReferenceKey)
            this.overrideFormControl(index, {
              key: environment.organizationWebVersionReferenceKey,
              value: data?.organizationWebVersion,
              keyFromDependency: data?.keyFromDependency 
            })            
          }
        })
  }

}
